import { Avatar, Chip, TableCell, TableRow, Typography } from "@mui/material";

import { Div } from "themes/jumbo/@jumbo/shared";
import { ProjectType } from "./types";
import { getCachedData } from "api/Cache";
import { tss } from "tss-react";
import { useHistory } from 'react-router-dom';
import { formatDateDetailed } from "services/UtilsService";
import { defaultThumbnailIcon } from "constants/common";
import { Scrollbars } from "react-custom-scrollbars";

const useStyles = tss.create(() => ({
  ellipsis: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box"
  },
  multiLineEllipsis: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical"
  },
  tableTr: {
    " &:hover": {
      background: 'rgba(0, 0, 0, .05)',
      cursor: 'pointer'
    }
  },
  tableTd: {
    padding: '8px 16px',
    fontSize: '0.813rem',
    height: '53px'
  }
}));

const ViewItem = ({ item, index, isDefaultProject }: { item: ProjectType, index: Number, isDefaultProject: boolean }) => {

  const { classes } = useStyles();
  //const { ID:projectID, name:projectName = 'Unknown Project', description:projectDescription = '', image = '', thumbnail = '', timezone } = item;
  const projects: any = getCachedData("projects");
  const projectName = projects[item.project] ? projects[item.project].name : "Unknown Project";
  const date = formatDateDetailed(item.file_date);
  const image = item.thumb ? item.thumb : defaultThumbnailIcon;

  const history = useHistory();
  const handleClick = (e: any) => {
      history.push(`/views/${item.ID}`);
  };

  return (
    <>
      {!index ? (
        <TableRow
          sx={{
            "td:first-of-type": {
              pl: 3,
            },
            "td:last-child": {
              pr: 3,
            },
          }}
        >
          <TableCell className={classes.tableTd}>
            <Typography 
              fontSize={'12px'}
              variant={'h6'}
              color={'text.secondary'}
              pl={6}
            >
              NAME
            </Typography>
          </TableCell>
          <TableCell className={classes.tableTd}  sx={{ display: {xs: 'none', sm: 'table-cell', md: 'table-cell', lg:'table-cell', xl: 'table-cell'}}}>
            <Typography 
              fontSize={'12px'}
              variant={'h6'}
              color={'text.secondary'}
            >
              PROJECT
            </Typography>
          </TableCell>
          <TableCell className={classes.tableTd} sx={{ display: {xs: 'none', sm: 'none', md: 'table-cell', lg:'table-cell', xl: 'table-cell'}}}>
            <Typography 
              fontSize={'12px'}
              variant={'h6'}
              color={'text.secondary'}
              textAlign={'center'}
            >
              DATE
            </Typography>
          </TableCell>
        </TableRow>
      ) : ""}
      <TableRow
        sx={{
          "td:first-of-type": {
            pl: 3,
          },
          "td:last-child": {
            pr: 3,
          },
        }}
        className={classes.tableTr}
        onClick={handleClick}
      >
        <TableCell className={classes.tableTd}>
          <Div sx={{ display: "flex", minWidth: 0, alignItems: "center" }}>
            <Avatar
                sx={{ width: "30px", height: "30px", mr: 2, bgcolor: 'rgba(32,32,32,.05)', borderRadius: '50%' }}
                alt={item.name}
                src={image}
                variant='rounded'
            />
            <Div sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="h5" mb={0.5} fontSize={14}>
                {item.name}
              </Typography>
            </Div>
          </Div>
        </TableCell>
        <TableCell className={classes.tableTd} sx={{ display: {xs: 'none', sm: 'table-cell', md: 'table-cell', lg:'table-cell', xl: 'table-cell'}}}>
          <Div sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Typography variant={'body1'} fontSize={12}>{projectName }</Typography>
            { isDefaultProject && (
              <Typography
                fontSize={'11px'}
                variant={'body1'}
                color={'rgba(61,171,230,.95)'}
              >
                Demo
              </Typography>
            )}
          </Div>
        </TableCell>
        <TableCell className={classes.tableTd} sx={{ display: {xs: 'none', sm: 'none', md: 'table-cell', lg:'table-cell', xl: 'table-cell'}}}>
          <Typography variant={'body1'} sx={{ fontSize: '12px !important' }} color={'text.secondary'} textAlign={'center'}>{date}</Typography>
        </TableCell>
      </TableRow>
    </>
  );
};
const EmptyViewItem = () => {

  const { classes } = useStyles();
  return (
    <TableRow
      sx={{
        "td:first-of-type": {
          pl: 3,
        },
        "td:last-child": {
          pr: 3,
        },
      }}
    >
      <TableCell colSpan={3}>
        <Div>
          <Typography
              fontSize={'13px'}
              variant={'body1'}
              color={'text.secondary'}
              sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '50px 0', height: '323px'}}
          >
              No Views found
          </Typography>
        </Div>
      </TableCell>
    </TableRow>
  );
};
export { ViewItem, EmptyViewItem };
